<div class="container-fluid mt-4">

  <!-- Add Part Button -->
  <button class="btn btn-primary mb-3" (click)="openModal(addPartModal)">+ ახალი ნაწილი</button>

  <!-- Table -->
  <table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th>#</th>
        <td>სურათი</td>
        <th>დასახელება (KA)</th>
        <th>დასახელება (EN)</th>
        <th>მოქ.</th>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of paginatedData; let i = index">
            <td>{{ (page-1)*pageSize + i + 1 }}</td>
            <td><img src="{{url}}/news/{{item.folder}}/{{item.image}}"></td>
            <td>{{ item.title_ka }}</td>
            <td>{{ item.title_en }}</td>
            <td>
            <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="editPart(item, addPartModal)"><i class="fi fi-rr-pencil"></i></button> 
                <button class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2" (click)="deletePart(item.id)"><i class="fi fi-rr-trash"></i></button> 
              </div>
            </td>
        </tr>
    </tbody>
  </table>

  <!-- Pagination -->
  <ngb-pagination 
    [(page)]="page" 
    [pageSize]="pageSize" 
    [collectionSize]="data?.length || 0" 
    (pageChange)="paginate()"
    [boundaryLinks]="true"
    [maxSize]="1"
    [ellipses]="false"
    class="d-flex justify-content-center">
  </ngb-pagination>

</div>

<!-- Add Part Modal -->
<ng-template #addPartModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">სიახლის დამატება</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <form [formGroup]="partForm" (ngSubmit)="savePart(modal)">
    <div class="modal-body">

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_ka" formControlName="title_ka" placeholder="Title (KA)">
        <label for="title_ka">დასახელება (KA)</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_en" formControlName="title_en" placeholder="Title (EN)">
        <label for="title_en">დასახელება (EN)</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_ru" formControlName="title_ru" placeholder="Title (RU)">
        <label for="title_ru">დასახელება (RU)</label>
      </div>

      <div class="form-floating mb-3">
        <textarea class="form-control" id="description_ka" formControlName="description_ka" placeholder="Description (KA)" style="height: 100px"></textarea>
        <label for="description_ka">აღწერა (KA)</label>
      </div>
      <div class="form-floating mb-3">
        <textarea class="form-control" id="description_en" formControlName="description_en" placeholder="Description (EN)" style="height: 100px"></textarea>
        <label for="description_en">აღწერა (EN)</label>
      </div>
      <div class="form-floating mb-3">
        <textarea class="form-control" id="description_ru" formControlName="description_ru" placeholder="Description (RU)" style="height: 100px"></textarea>
        <label for="description_ru">აღწერა (RU)</label>
      </div>

      <img *ngIf="partForm.get('image').value" src="{{url}}/news/{{partForm.get('folder').value}}/{{partForm.get('image').value}}">

      <div class="form-floating mt-3">
              <app-upload
              [uploadPath]="'news'"
              (fileUploaded)="onFileUploaded($event)"
             >
            </app-upload>   
          </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
      <button type="submit" class="btn btn-success">შენახვა</button>
    </div>
  </form>
</ng-template>